import { Papa } from 'ngx-papaparse';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogAddRows } from './../../dilog/add-rows.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SharedService } from '../../../shared.service';
import { ApiCallStatusService } from 'src/app/services/api-call-status.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { ViewChild } from '@angular/core';
import { Workbook } from 'exceljs';
import * as FileSaver from 'file-saver';
import notify from 'devextreme/ui/notify';

declare var $: any;




@Component({
  standalone: false,
    selector: 'app-cyl-dx-qty-form',
    templateUrl: './cyl-dx-qty-form.component.html',
    styleUrls: ['./cyl-dx-qty-form.component.scss']
})
export class CylDxQtyFormComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
    gridColumns: any[] = [];
    gridRows: any[] = [];
    requestForm: FormGroup;
    @Input() dataSource: any;
    @Output() optSelected: EventEmitter<any> = new EventEmitter();
    @Input() itemCatalogId: any;
    @Input() itemCatalogGroupId: any;
    @Input() focalId: any;
    @Input() itemTypeMasterId: any;
    @Input() companyBranchId: any;
    @ViewChild(DxDataGridComponent) grid!: DxDataGridComponent;
    @Input() acknowledgement: any;
    loadingIndicator: boolean;
    showGenerateBtn: boolean;
    isEdit: boolean;
    SPH_RANGE = [];
    CYL_RANGE = [];
    barCodeSph: any;
    barCodeCyl: any;
    rangeStockListPayload = [];
    toggleTypesOfValue;
    isCsv: boolean;
    actionSheetVisible: boolean;
    actionSheetTarget: any;
    sphError: boolean;
    cylError: boolean;
    stockIcon: boolean;
    inputType: boolean;
    totalQTY: number;
    totalToggle: boolean;
    loadingStockAvailable: boolean;
    availableStock: number;
    previousStock: boolean;
    currentStock: boolean;
    showPreviousStock: boolean;
    showCurrentStock: boolean;
    readonly: boolean;
    displayOnly: boolean;
    rangeLoading: boolean;
    loadingAllAvailableStock: boolean;
    hideClearBtn: boolean;
    isPreviousStockValueSetInput: boolean;
    constructor(
        private sharedService: SharedService,
        public dialog: MatDialog,
        private papa: Papa,
        private apiCallStatusSrvs: ApiCallStatusService
    ) {

    }
    isApiInProgress$ = this.apiCallStatusSrvs.isApiInProgress$;
    private availableStockCache = new Map<string, any[]>();
    private previousStockMap = new Map<string, number>();
    private currentStockMap = new Map<string, number>();
    private allowedRangeCells: Set<string> | null = null;

    get gridHeight(): number {
        return Math.min(520, Math.max(180, (this.gridRows?.length || 0) * 36 + 72));
    }

    ngOnInit() {
        this.totalQTY = 0;
        this.availableStock = 0;
        // this.showGenerateBtn = false;
        this.barCodeCyl = [];
        this.barCodeSph = [];
       // this.displayOnly = false;
    }
    private normalizeCode(v: any): string {
        return (v ?? '').toString().trim();
    }
    private existingDetailLookup(): Map<string, any> {
        const m = new Map<string, any>();
        for (const d of (this.dataSource?.rangeStockListPayload || [])) {
            const key = `${Number(d.sph)}|${Number(d.cyl)}`;
            m.set(key, d);
        }
        return m;
    }
    private parseQty(value: any): number | null {
        if (value === '' || value === null || value === undefined) {
            return null;
        }
        const parsed = Number(value);
        return Number.isNaN(parsed) ? null : parsed;
    }
    private hasDuplicateInSnapshot(snapshotRows: any[]): string[] {
        return [];
    }

    private computeGrandTotalFromGrid(): number {
        if (!Array.isArray(this.gridRows) || !Array.isArray(this.CYL_RANGE)) {
            return 0;
        }
        let total = 0;
        for (const row of this.gridRows) {
            for (const cyl of this.CYL_RANGE) {
                const qty = this.parseQty(row[this.colField(Number(cyl))]);
                if (qty !== null) {
                    total += qty;
                }
            }
        }
        return total;
    }

    calculateCustomSummary = (options: any) => {
        if (options.name !== 'grandTotal') {
            return;
        }
        if (options.summaryProcess === 'start') {
            options.totalValue = 0;
            return;
        }
        if (options.summaryProcess === 'finalize') {
            options.totalValue = this.computeGrandTotalFromGrid();
        }
    };
    private buildColumns(): void {
        const base = [{
            caption: 'SPH / CYL',
            dataField: '__sphKey',
            allowEditing: false,
            fixed: true,
            width: 110,
            dataType: 'number' as const,
            format: { type: 'fixedPoint', precision: 2 },
            alignment: 'right'
        }];

        const cylCols = (this.CYL_RANGE || []).map((cyl: number) => {
            const field = this.colField(cyl);
            return {
                caption: Number(cyl).toFixed(2),
                dataField: field,
                dataType: 'number' as const,
                width: 90,
                cssClass: 'cyl-col',
                alignment: 'right'
            };
        });

        this.gridColumns = [...base, ...cylCols];
    }
    onSaving(e: any) {
        // Make a snapshot of current rows and apply pending changes
        const snapshot = (this.gridRows || []).map(r => ({ ...r }));

        for (const ch of (e.changes || [])) {
            if (ch.type === 'update') {
                const key = ch.key?.__sphKey ?? ch.key;
                const rowIndex = snapshot.findIndex(r => r.__sphKey === key);
                if (rowIndex >= 0) {
                    Object.keys(ch.data || {}).forEach(df => {
                        snapshot[rowIndex][df] = ch.data[df];
                    });
                }
            }
        }

        const dups = this.hasDuplicateInSnapshot(snapshot);
        if (dups.length) {
            e.cancel = true;
            notify({
                message: `Duplicate barcode${dups.length > 1 ? 's' : ''} detected: ${dups.slice(0, 3).join(', ')}${dups.length > 3 ? 'â€¦' : ''}. Please ensure all barcodes are unique.`,
                type: 'error',
                width: 420,
                displayTime: 4000
            });
        }
    }

    exportToCsv() {
        // Commit any cell still in edit so we see its value
        this.grid?.instance.saveEditData();
        this.grid?.instance.closeEditCell?.();

        if (!this.gridRows?.length) {
            notify({ message: 'No data to export', type: 'warning', displayTime: 2000 });
            return;
        }

        // Header
        const headers = ['SPH / CYL', ...(this.CYL_RANGE || []).map(c => Number(c).toFixed(2))];
        let csv = headers.join(',') + '\n';

        // Rows
        for (const sph of (this.SPH_RANGE || [])) {
            const row: any[] = [Number(sph).toFixed(2)];
            const match = this.gridRows.find(r => Number(r.__sphKey) === Number(sph));
            for (const cyl of (this.CYL_RANGE || [])) {
                const field = this.colField(cyl);
                row.push(match ? (match[field] ?? '') : '');
            }
            csv += row.join(',') + '\n';
        }

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        FileSaver.saveAs(blob, 'StockGrid.csv');
    }

    exportToExcel() {
        // Same reason as CSV â€” commit pending edit
        this.grid?.instance.saveEditData();
        this.grid?.instance.closeEditCell?.();

        if (!this.gridRows?.length) {
            notify({ message: 'No data to export', type: 'warning', displayTime: 2000 });
            return;
        }

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Stock Grid');

        const headers = ['SPH / CYL', ...(this.CYL_RANGE || []).map(c => Number(c).toFixed(2))];
        worksheet.addRow(headers);

        for (const sph of (this.SPH_RANGE || [])) {
            const row: any[] = [Number(sph).toFixed(2)];
            const match = this.gridRows.find(r => Number(r.__sphKey) === Number(sph));
            for (const cyl of (this.CYL_RANGE || [])) {
                const field = this.colField(cyl);
                row.push(match ? (match[field] ?? '') : '');
            }
            worksheet.addRow(row);
        }

        workbook.xlsx.writeBuffer().then((buffer: any) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            FileSaver.saveAs(blob, 'StockGrid.xlsx');
        });
    }


    // Make cells readOnly if you previously disabled inputs via setBarCodeRange()
    onEditorPreparing(e: any) {
        if (e.parentType !== 'dataRow') return;

        if (e.dataField === '__sphKey') {
            e.editorOptions.readOnly = true;  // row header locked
            return;
        }

        const sph = e.row?.data?.__sphKey;
        const cyl = this.parseColField(e.dataField);
        if (!this.isCellAllowed(sph, cyl)) {
            e.editorOptions.readOnly = true;
        }
    }


    onCellClick(e: any) {
        // Start edit immediately when you click a data cell
        const dataField = e.column?.dataField;
        const cyl = dataField && dataField !== '__sphKey' ? this.parseColField(dataField) : null;
        if (dataField && dataField !== '__sphKey' && this.isCellAllowed(e.data?.__sphKey, cyl)) {
            e.component.editCell(e.rowIndex, e.columnIndex);
        }
    }


    // Paint stock badges or background
    onCellPrepared(e: any) {
        if (e.rowType !== 'data') return;
        if (e.column?.dataField === '__sphKey') return;

        const cell = e.cellElement as HTMLElement;
        const cyl = this.parseColField(e.column.dataField);
        const sph = e.data.__sphKey;

        if (!this.isCellAllowed(sph, cyl)) {
            cell.classList.add('stock-audit-cell-disabled');
        } else {
            cell.classList.remove('stock-audit-cell-disabled');
        }

        // Current stock label (optional quick visual)
        if (this.currentStock && Array.isArray(this.dataSource?.rangeStockListPayload)) {
            const hit = this.dataSource.rangeStockListPayload.find(x =>
                Number(x.sph) === Number(sph) && Number(x.cyl) === Number(cyl));
            if (hit?.vendorItemCode != null && hit.vendorItemCode !== '') {
                cell.setAttribute('title', `Current: ${hit.vendorItemCode}`);
            }
        }

        const cellKey = this.buildCellKey(sph, cyl);
        const prevValue = this.previousStock ? this.previousStockMap.get(cellKey) : null;
        this.renderBadge(cell, 'prev-stock-chip', prevValue);

        const currValue = this.currentStock ? this.currentStockMap.get(cellKey) : null;
        this.renderBadge(cell, 'current-stock-chip', currValue);
    }

    onCellValueChanged(e: any) {
        if (!e || !e.column || e.column.dataField === '__sphKey') return;

        const cyl = this.parseColField(e.column.dataField);
        const sph = Number(e.data.__sphKey);
        const next = this.normalizeCode(e.value);

        // Reuse your existing mechanism to upsert this cell into payload
        const hiddenId = `${sph}_${cyl}`;
        this.getRangeValues(next, cyl, sph, hiddenId);
        this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload || [], 'vendorItemCode');
    }


    ngAfterViewInit() {
        $(document).ready(() => {
            var element = null;
            $('table tr td input').focus((e) => {
               element =  e.target.parentNode.parentNode.parentNode;
               $(element).find('th').css('background-color', 'lightgreen');
            }).blur(() => {
               $(element).find('th').css('background-color', 'inherit');
            })
        })
    }
    // get readOnlyforGen () {
    //     if (this.showGenerateBtn) {
    //         return false;
    //     } else {
    //         return true;
    //     }
    // }

  
    readCSV(event: any) {
        const files: FileList = event?.target?.files;
        if (!files || !files.length) return;

        // Commit any pending editor so we don't lose the last edit
        try {
            this.grid?.instance.saveEditData();
            this.grid?.instance.closeEditCell?.();
        } catch { }

        const file = files.item(0)!;
        const reader = new FileReader();

        reader.onload = () => {
            // Strip BOM, normalize
            const raw = String(reader.result ?? '').replace(/^\uFEFF/, '');

            const parsed = this.papa.parse(raw, {
                skipEmptyLines: true,
                dynamicTyping: false, // keep barcodes as strings
                delimiter: ''         // auto-detect
            });

            const rows: any[][] = parsed.data as any[][];
            if (!rows?.length) {
                notify({ message: 'CSV is empty or malformed.', type: 'error', displayTime: 2500 });
                return;
            }

            // Header: ["SPH / CYL", 0.00, -0.25, ...]  â†’ derive CYL columns
            const header = rows[0].map(h => (h ?? '').toString().trim());
            const hasRangeHeader = /sph\s*\/\s*cyl/i.test(header[0] || '');

            // Preserve the original stock-audit CSV format: quantities only,
            // positioned against the range that is already displayed.
            if (!hasRangeHeader) {
                if (!this.SPH_RANGE?.length || !this.CYL_RANGE?.length) {
                    notify({ message: 'Generate the SPH/CYL range before uploading CSV.', type: 'warning', displayTime: 2500 });
                    return;
                }

                this.rebuildGrid();
                rows.slice(0, this.SPH_RANGE.length).forEach((csvRow, rowIndex) => {
                    const gridRow = this.gridRows[rowIndex];
                    this.CYL_RANGE.forEach((cyl, columnIndex) => {
                        const rawValue = (csvRow[columnIndex] ?? '').toString().replace(/\r/g, '').trim();
                        gridRow[this.colField(cyl)] = rawValue === '' ? '' : this.parseQty(rawValue);
                    });
                });

                this.gridRows = [...this.gridRows];
                this.syncDetailsFromGrid();
                this.totalQTY = this.computeGrandTotalFromGrid();
                this.grid?.instance?.refresh();
                notify({ message: 'CSV loaded.', type: 'success', displayTime: 1500 });
                return;
            }

            // Also accept files exported from this grid with SPH/CYL headers.
            const cylHeaders = header
                .slice(1)
                .map(h => Number(String(h).replace(/[^\d.\-]/g, ''))) // tolerate spaces/symbols
                .filter(n => !Number.isNaN(n));

            if (!cylHeaders.length) {
                notify({ message: 'No CYL columns found in CSV header.', type: 'error', displayTime: 2500 });
                return;
            }

            // Body â†’ grid rows + SPH list
            const newRows: any[] = [];
            const sphValues: number[] = [];

            for (const r of rows.slice(1)) {
                if (!r?.length) continue;

                const sph = Number(String(r[0]).replace(/[^\d.\-]/g, ''));
                if (Number.isNaN(sph)) continue;

                const rowObj: any = { __sphKey: sph };
                cylHeaders.forEach((cyl, idx) => {
                    const cell = (r[idx + 1] ?? '').toString().replace(/\r/g, '').trim();
                    rowObj[this.colField(cyl)] = cell === '' ? '' : this.parseQty(cell);
                });

                newRows.push(rowObj);
                sphValues.push(sph);
            }

            if (!newRows.length) {
                notify({ message: 'No rows found in CSV.', type: 'error', displayTime: 2500 });
                return;
            }

            // Set ranges and datasource (preserve SPH order, de-dup)
            const seen = new Set<number>();
            const orderedSPH = sphValues.filter(v => (seen.has(v) ? false : (seen.add(v), true)));

            this.CYL_RANGE = cylHeaders;
            this.SPH_RANGE = orderedSPH;
            this.gridRows = newRows;

            // Rebuild grid columns + datasource (keep alignment/formatting)
            const columns = [
                {
                    dataField: '__sphKey',
                    caption: 'SPH / CYL',
                    allowEditing: false,
                    width: 110,
                    dataType: 'number' as const,
                    format: { type: 'fixedPoint', precision: 2 },
                    alignment: 'right' as const
                },
                ...this.CYL_RANGE.map(cyl => ({
                    dataField: this.colField(cyl),
                    caption: Number(cyl).toFixed(2),
                    dataType: 'number' as const,
                    width: 90,
                    cssClass: 'cyl-col',
                    alignment: 'right' as const
                })),
            ];

            if (this.grid?.instance) {
                this.grid.instance.option('columns', columns);
                this.grid.instance.option('dataSource', this.gridRows);
                this.grid.instance.refresh();
            } else {
                // fallback if instance not ready
                this.rebuildGrid();
            }

            // Remove duplicates that came from CSV
            const dups = this.hasDuplicateInSnapshot(this.gridRows);
            if (dups.length) {
                notify({
                    message: `CSV contains duplicate barcode${dups.length > 1 ? 's' : ''}: ${dups.slice(0, 6).join(', ')}${dups.length > 6 ? '...' : ''}. Later duplicates were cleared.`,
                    type: 'error',
                    width: 460,
                    displayTime: 4500
                });
                const seen = new Set<string>();
                for (const row of this.gridRows) {
                    for (const cyl of this.CYL_RANGE) {
                        const field = this.colField(cyl);
                        const code = this.normalizeCode(row[field]);
                        if (!code) continue;
                        if (seen.has(code)) {
                            row[field] = '';
                        } else {
                            seen.add(code);
                        }
                    }
                }
                // Push cleared cells into the grid UI
                try { this.grid?.instance?.option('dataSource', this.gridRows); this.grid?.instance?.refresh?.(); } catch {}
            }

            // Update payload + totals after cleanup
            this.syncDetailsFromGrid();
            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');

            notify({ message: 'CSV loaded.', type: 'success', displayTime: 1500 });
        };

        reader.readAsText(file);

        // Let user pick the same file again
        if (event?.target) event.target.value = '';
    }




    getInitForm() {
        this.requestForm = new FormGroup({
            sections: new FormArray([])
        });
    }

    /**
     * @name ngOnChanges
     * @desc Fires when change in input properties are detected
     * @return void
     */
    ngOnChanges(changes: SimpleChanges) {
        this.getInitForm();
        this.availableStockCache.clear();
        this.allowedRangeCells = null;
        if (Object.keys(changes.dataSource.currentValue).length > 0) {
            this.rangeStockListPayload = [];
            this.previousStock = false;
            this.inputType = changes.dataSource.currentValue.inputType;
            this.stockIcon = changes.dataSource.currentValue.stockIcon;
            this.totalToggle = changes.dataSource.currentValue.totalToggle;
            this.showCurrentStock = changes.dataSource.currentValue.showCurrentStock;
            this.showPreviousStock = changes.dataSource.currentValue.showPreviousStock;
            this.hideClearBtn = changes.dataSource.currentValue.hideClearBtn;
            this.showGenerateBtn = changes.dataSource.currentValue.generateBtn;
            this.isPreviousStockValueSetInput = changes.dataSource.currentValue.isPreviousStockValueSetInput;
           // this.previousStock = changes.dataSource.currentValue.previousStock;
            this.readonly = changes.dataSource.currentValue.readonly;
            this.displayOnly = changes.dataSource.currentValue.displayOnly;
            
            this.addSection(changes.dataSource.currentValue);
            if (!this.showGenerateBtn) {
                this.checkRange();
            }
            if (changes.dataSource.currentValue.isEdit) {
                this.isPreviousStockValueSetInput = false;
                if (changes.dataSource.currentValue.rangeStockListPayload) {
                     this.setInventoryFormData(changes.dataSource.currentValue.rangeStockListPayload);
                }
                this.isEdit = true;
            }
            if (changes.dataSource.currentValue.rangeOption) {
                const payload = {
                    itemCatalogGroupId: this.itemCatalogGroupId,
                    itemTypeMasterId: this.itemTypeMasterId,
                    focalId: this.focalId,
                    sphmin: (changes.dataSource.currentValue.barCodeData.sphmin || changes.dataSource.currentValue.barCodeData.sphmin == 0) ? changes.dataSource.currentValue.barCodeData.sphmin : 0,
                    sphmax: (changes.dataSource.currentValue.barCodeData.sphmax || changes.dataSource.currentValue.barCodeData.sphmax == 0)  ? changes.dataSource.currentValue.barCodeData.sphmax : 0,
                    cylmin: (changes.dataSource.currentValue.barCodeData.cylmin || changes.dataSource.currentValue.barCodeData.cylmin == 0)  ? changes.dataSource.currentValue.barCodeData.cylmin : 0,
                    cylmax: (changes.dataSource.currentValue.barCodeData.cylmax || changes.dataSource.currentValue.barCodeData.cylmax == 0) ? changes.dataSource.currentValue.barCodeData.cylmax : 0,
                    addmin: (changes.dataSource.currentValue.barCodeData.addmin || changes.dataSource.currentValue.barCodeData.addmin == 0)  ? changes.dataSource.currentValue.barCodeData.addmin : 0,
                    addmax: (changes.dataSource.currentValue.barCodeData.addmax || changes.dataSource.currentValue.barCodeData.addmax == 0) ? changes.dataSource.currentValue.barCodeData.addmax : 0,
                    cxmin:  (changes.dataSource.currentValue.barCodeData.cxmin || changes.dataSource.currentValue.barCodeData.cxmin == 0) ? changes.dataSource.currentValue.barCodeData.cxmin : 0,
                    cxmax:  (changes.dataSource.currentValue.barCodeData.cxmax || changes.dataSource.currentValue.barCodeData.cxmax == 0) ? changes.dataSource.currentValue.barCodeData.cxmax : 0,
                };
                // this.barCodeSph = this.sharedService.generateRange((changes.dataSource.currentValue.sphmin as string).replace('-',''),(changes.dataSource.currentValue.sphmax as string).replace('-',''), 0.25);
                // this.barCodeCyl = this.sharedService.generateRange((changes.dataSource.currentValue.cylmin as string).replace('-',''),(changes.dataSource.currentValue.cylmax as string).replace('-',''), 0.25);
                this.validateBarcodeRequestRange(payload);
            }
        }
    }

    /**
     * @name addSection
     * @param data
     * @returns void
     * @description create section array
     */
    addSection(data?: any): void {
        if (data) {
            if (data.active) {
                this.showGenerateBtn = data.generateBtn;
                this.isCsv = data.csv;
                this.sectionsArray.push(this.createSection(data));
            }
        }
    }

    /**
     * @name createSection
     * @param data
     * @return FormGroup
     * @description section controls
     */
    createSection(data?: any): FormGroup {
        return new FormGroup({
            condition: new FormControl(data ? data.condition : '', []),
            active: new FormControl(data ? data.active : false, []),
            childern: new FormArray(this.addChildern(data.childern)),
        });
    }


    /**
     * @name addChildern
     * @param data
     * @returns childern array
     */
    addChildern(data?: any) {
        const formArray = [];
        data.forEach(child => {
            formArray.push(this.createChild(child));
        });
        return formArray;
    }

    /**
     * @name createChild
     * @param child
     * @return  childer controls
     * @deprecated child formcontrols
     */
    createChild(child?): FormGroup {
        return new FormGroup({
            name: new FormControl(child ? child.name : '', []),
            min: new FormControl(child ? child.min : '', [Validators.required]),
            max: new FormControl(child ? child.max : '', [Validators.required]),
            // min: new FormControl(child ? (child.valueType ? child.min : child.min.toString().replace('-','')) : '', [Validators.required]),
            // max: new FormControl(child ? (child.valueType ? child.max : child.max.toString().replace('-','')) : '', [Validators.required]),
            valueType: new FormControl(child.valueType, [])
            // valueType: new FormControl(child.name === 'CYL' ? true : false, [])
        });
    }


    /**
     * @name getAvailableStock
     * @param {*} e
     * @param {*} sph
     * @param {*} cyl
     * @memberof CylFormComponent
     */
    getAvailableStock(e, sph: any, cyl: any) {
        this.availableStock = 0;
        this.loadingStockAvailable = true;
        let payload = {
            itemCatalogGroupId: this.itemCatalogGroupId,
            sph: sph,
            cylOrAdd: cyl
        };
        this.sharedService.getAvailableStock(payload)
            .then((response: any) => {
                if (response.data.completed) {
                    this.loadingStockAvailable = false;
                    this.availableStock = response.data.payload;
                    this.actionSheetTarget = '#img-' + e;
                    this.actionSheetVisible = true;
                } else {
                    this.loadingStockAvailable = false;
                    this.availableStock = 0;
                    console.error(response);
                }
            })
            .catch(error => {
                this.availableStock = 0;
                this.loadingStockAvailable = false;
                console.log(error);

            });

    }

   

    /**
   * @name validateBarcodeRequestRange
   * @param {number} itemCatalogGroupId
   * @param {number} itemTypeMasterId
   * @param {number} focalId
   * @param {number} sphmin
   * @param {number} sphmax
   * @param {number} cylmin
   * @param {number} cylmax
   * @param {*} payload
   * @returns
   * @memberof SharedService
   */
    validateBarcodeRequestRange(payload) {
       this.rangeLoading = true;
        this.sharedService.validateBarcodeRequestRange(payload)
            .then((response: any) => {
                if (response.data.completed && response.data.payload.length > 0) {
                    this.rangeLoading = false;
                    this.setBarCodeRange(response.data.payload);
                } else {
                    this.rangeLoading = false;
                    console.error(response);
                }
            })
            .catch(error => {
                this.rangeLoading = false;
                console.log(error);

            });

    }
    /**
     * @name sectionsArray
     * @returns section array controls
     */
    get sectionsArray() {
        return this.requestForm.get('sections') as FormArray;
    }

    /**
     * @name getChildern
     * @param form section item index
     * @returns childern array controls
     */
    getChildern(form) {
        return form.controls.childern.controls;
    }

  


    /**
     * @name clearField
     * @return void
     */
    clearField(): void {
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').setValue('');
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue('');
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').setValue('');
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue('');
        // const child = (this.requestForm.get('sections') as FormArray).at(0).get('childern') as FormArray;
        // while (child.length !== 0) {
        //     child.removeAt(0);
        // }
        this.rangeStockListPayload = [];
        this.SPH_RANGE = [];
        this.CYL_RANGE = [];
        this.gridRows = [];
        this.gridColumns = [];
        this.totalQTY = 0;
        this.previousStockMap.clear();
        this.currentStockMap.clear();
    }
    get availableStockInHand() {
        return Math.floor(Math.random() * 500);
    }

    /**
     * @name addRows
     * @return number of rows
     * @description modal popup
     */
    addRows() {
        const dialogRef = this.dialog.open(DialogAddRows, {
            width: '250px',
            data: { label: 'CYL' }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.rows) {
                for (let i = 0; i < parseInt(result.rows); i++) {
                    // this.createCxTypeDetail();
                    this.updatedMaxVal('increment');
                }
            }
        });
    }

    /**
     * @name incrementMaxVal
     * @returns updated max value
     */
    updatedMaxVal(label: string) {
        const val = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
        if (label === 'increment') {
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue(parseInt(val) + 1);
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue(parseInt(val) + 1);
        }
        if (label === 'decrement') {
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue(parseInt(val) - 1);
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue(parseInt(val) - 1);
        }
    }

    /**
     * @name removeIndex
     * @param index
     * @return void
     * @description removing row index
     */
    removeIndex(index) {
        // this.SPH_RANGE.splice(index, 1);
        // this.CYL_RANGE.splice(index, 1);
        // const item = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
        // item.removeAt(index);
        this.updatedMaxVal('decrement');
        // ((this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray).removeAt(index);
    }

    getRangeValues(val, cyl, sph, hiddenId?: any) {
        const qty = this.parseQty(val);

        if (qty === null) {
            for (let i = 0; i < this.rangeStockListPayload.length; i++) {
                if (
                    this.rangeStockListPayload[i].cyl === cyl &&
                    this.rangeStockListPayload[i].sph === sph
                ) {
                    this.rangeStockListPayload.splice(i, 1);
                    break;
                }
            }
            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
            return;
        }

        if (this.rangeStockListPayload.some(o => o.cyl === cyl && o.sph === sph)) {
            for (let i = 0; i < this.rangeStockListPayload.length; i++) {
                if (
                    this.rangeStockListPayload[i].cyl === cyl &&
                    this.rangeStockListPayload[i].sph === sph
                ) {
                    this.rangeStockListPayload[i]['vendorItemCode'] = qty;
                    this.rangeStockListPayload[i]['status'] = 'active';
                    break;
                }
            }
            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
        } else {
            const rangePairObj = {
                cx: null,
                cxtypeId: null,
                vendorItemCode: qty,
                cc: null,
                add: null,
                axis: null,
                cyl: cyl,
                ct: null,
                et: null,
                tc: null,
                wt: null,
                sph: sph,
                vendorItemCatalogId: hiddenId,
                status: 'active'
            };
            this.rangeStockListPayload.push(rangePairObj);
            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
        }
    }

    // overLapRange(sph_min: any, sph_max: any, cyl_min: any, cyl_max: any) {
    //     let tempSPH_RANGE = [];
    //     let tempCYL_RANGE = [];
    //     if (sph_min && sph_max) {
    //         if (sph_max < sph_min) {
    //             return this.sphError = true;
    //         } else {
    //             this.sphError = false;
    //             if ((sph_min && sph_max || sph_min === 0 && sph_max || sph_min === 0 && sph_max == 0 || sph_min && sph_max === 0)) {
    //                 tempSPH_RANGE = this.sharedService.generateRange(
    //                     sph_min,
    //                     sph_max,
    //                     0.25
    //                   );
    //             }
    //         }
    //     }
    //     if (cyl_max < cyl_min) {
    //         return this.cylError = true;
    //     } else {
    //         this.cylError = false;
    //          if ((cyl_min && cyl_max || cyl_min === 0 && cyl_max || cyl_min === 0 && cyl_max === 0 || cyl_min && cyl_max === 0)) {
    //             tempCYL_RANGE = this.sharedService.generateRange(
    //                     cyl_min,
    //                     cyl_max,
    //                     0.25
    //                   );
    //             if (this.check_number(cyl_min)) {
    //                 tempCYL_RANGE.reverse();
    //             }
    //         } 
    //     }
    //     console.log('tempSPH_RANGE', tempSPH_RANGE.length)
    //     console.log('tempCYL_RANGE', tempCYL_RANGE.length)
    //     console.log('this.SPH_RANGE', this.SPH_RANGE.length)
    //     console.log('this.CYL_RANGE', this.CYL_RANGE.length)
    //     this.SPH_RANGE.forEach((sph, sphIndex) => {
    //         this.CYL_RANGE.forEach((cyl, index) => {
    //             if (tempSPH_RANGE.includes(sph) && tempCYL_RANGE.includes(cyl)) {
    //                 $('table tr td #delete-' + sphIndex + '-' + index).addClass('fa fa-trash d-none');
    //             } else {
    //                 $('table tr td #delete-' + sphIndex + '-' + index).removeClass('d-none');
    //             }
    //             // dataSource.forEach(data => {
    //             //     if (data.sph == sph.toString() && data.cyl == cyl.toString()) {
    //             //         setTimeout(() => {
    //             //              $('table tr td #currentStock-' + sphIndex + '-' + index).text(data.vendorItemCode);
    //             //         }, 10);
    //             //     }
    //             // });
    //         });
    //     });
        
    // }
    checkRange() {
        this.SPH_RANGE = [];
        this.CYL_RANGE = [];
        const sph_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').value;
        const sph_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
        const sph_valueType = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('valueType').value;
        const cyl_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').value;
        const cyl_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').value;
        const cyl_valueType = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('valueType').value;
        if (parseFloat(sph_max) < parseFloat(sph_min)) {
            return this.sphError = true;
        } else {
            this.sphError = false;
            if ((sph_min && sph_max || sph_min === 0 && sph_max || sph_min === 0 && sph_max == 0 || sph_min && sph_max === 0)) {
                // if ((sph_min !== "" || sph_min == 0 ) && (sph_max !== "" || sph_max == 0) && sph_min !== null && sph_max !== null) {
                    this.SPH_RANGE = this.sharedService.generateRange(
                        parseFloat(sph_min),
                        parseFloat(sph_max),
                        0.25
                      );
                // this.SPH_RANGE = this.sharedService.generateRange(sph_valueType ? -sph_max : sph_min, sph_valueType ? -sph_min : sph_max, 0.25);
                if (this.check_number(parseFloat(sph_min))) {
                    this.SPH_RANGE.reverse();
                }
            } else {
                this.SPH_RANGE = null;
            }
        }
        if (parseFloat(cyl_max) < parseFloat(cyl_min)) {
            return this.cylError = true;
        } else {
            this.cylError = false;
             if ((cyl_min && cyl_max || cyl_min === 0 && cyl_max || cyl_min === 0 && cyl_max === 0 || cyl_min && cyl_max === 0)) {
                // if ((cyl_min !== "" || cyl_min == 0) && (cyl_max !== "" || cyl_max == 0) && cyl_min !== null && cyl_max !== null) {
                    this.CYL_RANGE = this.sharedService.generateRange(
                        parseFloat(cyl_min),
                        parseFloat(cyl_max),
                        0.25
                      );
                // (cyl_max < cyl_min) ? this.isCylInvalid = true : this.isCylInvalid = false;
                // this.CYL_RANGE = this.sharedService.generateRange(cyl_valueType ? -cyl_max : cyl_min, cyl_valueType ? -cyl_min : cyl_max, 0.25);
                if (this.check_number(parseFloat(cyl_min))) {
                    this.CYL_RANGE.reverse();
                }
            } else {
                this.CYL_RANGE = null;
            }
        }
        this._afterCheckRangeGridRefresh();
    }

      
  /**
   * @name check_number
   * @param num_value
   * @returns bool
   */
  check_number(num_value) {
    if (num_value >= 0) {
      return false;
    } else {
      return true;
    }
  }
    toggleStock(label: string, change?: MatSlideToggleChange) {
       switch (label) {
           case 'previous': {
               const nextState = typeof change?.checked === 'boolean' ? change.checked : !this.previousStock;
            const stateChanged = nextState !== this.previousStock;

            if (change && !stateChanged) {
                return;
            }

            this.previousStock = nextState;
            if (!this.previousStock) {
                this.previousStockMap.clear();
                this.refreshGridBadges();
                return;
            }

            const isPositiveRange = this.isPositiveRange();
            const cacheKey = this.buildAvailableStockCacheKey(this.companyBranchId, this.itemCatalogGroupId, isPositiveRange);

            if (this.availableStockCache.has(cacheKey)) {
                this.setAvailableStock(this.availableStockCache.get(cacheKey) || []);
                return;
            }

            this.getAllAvailableStock(this.companyBranchId, this.itemCatalogGroupId, isPositiveRange, cacheKey);
            break;
        }
         case 'current':
            this.currentStock = typeof change?.checked === 'boolean' ? change.checked : !this.currentStock;
            if (!this.currentStock) {
                this.currentStockMap.clear();
                this.refreshGridBadges();
                break;
            }
            this.setCurrentStock(this.dataSource.rangeStockListPayload);
          break;
    }
 }
     /**
   * @name getAllAvailableStock
   * @param {number} companyBranchId
   * @param {number} itemCatalogGroupId
   * @param {number} isPositiveRange
   * @returns
   * @memberof SharedService
   */
  getAllAvailableStock(companyBranchId: number, itemCatalogGroupId: number, isPositiveRange: boolean, cacheKey?: string) {
    if (this.loadingAllAvailableStock) {
        return;
    }
    this.loadingAllAvailableStock = true;
    this.sharedService.getAllAvailableStock(companyBranchId, itemCatalogGroupId, isPositiveRange)
        .then((response: any) => {
            if (response.data.completed) {
            this.checkRange();
            this.loadingAllAvailableStock = false;
            const payload = response.data.payload?.availableStock || [];
            if (cacheKey) {
                this.availableStockCache.set(cacheKey, payload);
            }
            this.setAvailableStock(payload);
            } else {
                this.loadingAllAvailableStock = false;
                console.error(response);
            }
        })
        .catch(error => {
            this.loadingAllAvailableStock = false;
            console.log(error);

        });

 }
  /**
     * @name setCurrentStock
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setAvailableStock(dataSource: any[]) {
        this.previousStockMap.clear();
        if (!this.previousStock) {
            this.refreshGridBadges();
            return;
        }

        if (!Array.isArray(dataSource) || !dataSource.length) {
            this.refreshGridBadges();
            return;
        }

        dataSource.forEach((data) => {
            const key = this.buildCellKey(data?.sph, data?.cyl);
            const qty = Number(data?.availableStock ?? data?.available ?? data?.qty);
            if (!Number.isFinite(qty)) {
                return;
            }
            this.previousStockMap.set(key, qty);

            if (this.isPreviousStockValueSetInput) {
                this.applyStockValueToGrid(data?.sph, data?.cyl, qty);
                this.getRangeValues(qty, Number(data?.cyl), Number(data?.sph));
            }
        });

        this.refreshGridBadges();
    }
 /**
     * @name setCurrentStock
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setCurrentStock(dataSource: any[]) {
        this.currentStockMap.clear();
        if (!this.currentStock) {
            this.refreshGridBadges();
            return;
        }

        if (!Array.isArray(dataSource) || !dataSource.length) {
            this.refreshGridBadges();
            return;
        }

        dataSource.forEach((data) => {
            const key = this.buildCellKey(data?.sph, data?.cyl);
            const qty = Number(data?.vendorItemCode ?? data?.qty);
            if (!Number.isFinite(qty)) {
                return;
            }
            this.currentStockMap.set(key, qty);
        });

        this.refreshGridBadges();
    }
    /**
     * @name setInventoryFormData
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setInventoryFormData(dataSource) {
        this.SPH_RANGE.forEach((sph, sphIndex) => {
            this.CYL_RANGE.forEach((cyl, index) => {
                dataSource.forEach(data => {
                    if (data.sph == sph.toString() && data.cyl == cyl.toString()) {
                        this.getRangeValues(data.vendorItemCode, cyl, sph, 'hidden-' + sphIndex + '-' + index);
                        setTimeout(() => {
                            $('table tr td #input-' + sphIndex + '-' + index).val(data.vendorItemCode);
                            $('table tr td #hidden-' + sphIndex + '-' + index).val(data.vendorItemCatalogId);
                            if (this.isEdit) {
                                this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
                            }
                        }, 10);
                    }
                });
            });
        });
    }
    /**
     * @name setInventoryFormData
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setBarCodeRange(dataSource: any[]) {
        this.allowedRangeCells = new Set(
            (dataSource || []).map(data => this.buildAllowedCellKey(data?.sph, data?.cyl))
        );
        this.grid?.instance?.refresh();
    }
    /***
     * @name toggleGenerateBtn
     * @returns boolean;
     */
    toggleGenerateBtn() {
        if (((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).length > 0) {
            const sph_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').value;
            const sph_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
            const cyl_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').value;
            const cyl_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').value;
                if ((sph_min !== "" && sph_max !== "" && cyl_min !== "" && cyl_max !== "") && ((sph_min || sph_min == 0) && (sph_max || sph_max == 0) && (cyl_min || cyl_min == 0) && (cyl_max || cyl_max == 0))){
                    
                    if  (parseFloat(cyl_max) > parseFloat(cyl_min) && parseFloat(sph_max) > parseFloat(sph_min)) {
                        return true;
                   } else {
                    return false;
                   }
                }
           
           
            // if (
            //     (sph_min && sph_max && cyl_min && cyl_max) ||
            //     (sph_min === 0 && sph_max && cyl_min === 0 && cyl_max) ||
            //     (sph_min === 0 && sph_max && cyl_min && cyl_max) ||
            //     (cyl_min === 0 && cyl_max && sph_min && sph_max) || (sph_min === 0 && sph_max === 0 && cyl_min === 0 && cyl_max === 0) || (sph_min === 0 && sph_max === 0 && cyl_min && cyl_max === 0)) {
            //     return true;
            // } else {
            //     return false;
            // }
        }
    }

    fixVerticalTabindex(selector) {
        if (typeof selector == 'undefined') {
            selector = '.reset-tabindex';
        }
        let tabindex = 1;
        $(selector).each((i, tbl) => {
            $(tbl).find('tr').first().find('td').each((clmn, el) => {
                $(tbl).find('tr td:nth-child(' + (clmn + 1) + ') div input').each((j, input) => {
                    $(input).attr('placeholder', tabindex);
                    $(input).attr('tabindex', tabindex++);
                });
            });
        });
    }
  

    private syncDetailsFromGrid(): void {
        const lookup = this.existingDetailLookup();
        const out: any[] = [];

        for (const row of (this.gridRows || [])) {
            const sph = Number(row.__sphKey);
            for (const cyl of (this.CYL_RANGE || [])) {
                const field = this.colField(cyl);
                const qty = this.parseQty(row[field]);
                if (qty !== null) {
                    const key = `${sph}|${Number(cyl)}`;
                    const ex = lookup.get(key) || {};
                    out.push({
                        sph,
                        cyl: Number(cyl),
                        vendorItemCode: qty,
                        vendorItemCatalogId: Number(ex.vendorItemCatalogId || 0),
                        vendorItemCatalogDetailId: Number(ex.vendorItemCatalogDetailId || 0),
                        status: 'active',
                        active: true,
                    });
                }
            }
        }

        this.rangeStockListPayload = out;
    }


      /**
     * @name saveStockRequest
     * @param {FormGroup} requestForm
     * @returns payload form cxtypedetail
     */

    saveStockRequest(requestForm: FormGroup) {
        this.loadingIndicator = true;

        // Commit last edit and rebuild payload
        this.grid?.instance.saveEditData();
        this.grid?.instance.closeEditCell?.();
        this.syncDetailsFromGrid();
        this.totalQTY = this.computeGrandTotalFromGrid();

        // Final duplicate guard (CSV/manual edge-cases)
        const snapshot = (this.gridRows || []).map(r => ({ ...r }));
        const dups = this.hasDuplicateInSnapshot(snapshot);
        if (dups.length) {
            notify({
                message: `Duplicate barcode${dups.length > 1 ? 's' : ''} found: ${dups.slice(0, 5).join(', ')}${dups.length > 5 ? 'â€¦' : ''}. Please remove duplicates before saving.`,
                type: 'error',
                width: 420,
                displayTime: 4000
            });
            this.loadingIndicator = false;
            return;
        }

        // Range min/max (as you had)
        const sph_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').value;
        const sph_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
        const cyl_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').value;
        const cyl_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').value;

        // Only active items should be sent; backend handles deletions
        const finalList = (this.rangeStockListPayload || []).filter(x => x && (x.vendorItemCode ?? '') !== '');

        const payload = {
            sphmin: sph_min,
            sphmax: sph_max,
            cylmin: cyl_min,
            cylmax: cyl_max,
            rangeStockListPayload: finalList,
            totalQTY: this.totalQTY
        };

        if (requestForm.invalid) {
            this.loadingIndicator = false;
            return;
        }

        // Emit up to parent (your parent already calls submitData($event))
        this.optSelected.emit(payload);
        setTimeout(() => { this.loadingIndicator = false; }, 300);
    }




    // Formats a CYL to a safe dataField (e.g., -1.25 -> "c_m1_25", 0.5 -> "c_0_5")
    private colField(cyl: number): string {
        const s = Number(cyl).toFixed(2).replace('-', 'm').replace('.', '_');
        return `c_${s}`;
    }

    // Reverse: get the numeric cyl back from a dataField name
    private parseColField(field: string): number {
        // field like "c_m1_25" or "c_0_50"
        const raw = field.slice(2).replace('m', '-').replace('_', '.');
        // handle second underscore in cases like m1_25 -> replace only first '_'
        const parts = raw.split('_');
        const num = Number(parts[0] + (parts[1] ? '.' + parts[1] : ''));
        return num;
    }

//     // Build DevExtreme columns dynamically from CYL_RANGE
//    private buildColumns(): void {
//   const base = [
//     {
//       caption: 'SPH / CYL',
//       dataField: '__sphKey',
//       allowEditing: false,
//       fixed: true,
//       width: 110,
//     }
//   ];

//   const cylCols = (this.CYL_RANGE || []).map((cyl) => {
//     const field = this.colField(cyl);
//     return {
//       caption: `${cyl}`,
//       dataField: field,
//       dataType: 'string' as const,             // <- editable text
//       allowEditing: !this.readonly && !this.acknowledgement
//       // â›”ï¸ no cellTemplate here
//     };
//   });

//   this.gridColumns = [...base, ...cylCols];
// }


    // Build rows from SPH_RANGE and preload any known codes
    // Uses your existing rangeStockListPayload to seed cell values
    private buildRows(): void {
        const rows: any[] = [];
        const lookup = new Map<string, string>(); // "sph|cyl" -> vendorItemCode

        const seed = this.rangeStockListPayload?.length
            ? this.rangeStockListPayload
            : (this.dataSource?.rangeStockListPayload || []);

        for (const it of (seed || [])) {
            lookup.set(`${Number(it.sph)}|${Number(it.cyl)}`, this.normalizeCode(it.vendorItemCode));
        }

        for (const sph of (this.SPH_RANGE || [])) {
            const row: any = { __sphKey: Number(sph) };
            for (const cyl of (this.CYL_RANGE || [])) {
                const key = `${Number(sph)}|${Number(cyl)}`;
                row[this.colField(cyl)] = lookup.get(key) ?? '';
            }
            rows.push(row);
        }

        this.gridRows = rows;
    }
    // Rebuild grid whenever ranges change or data is loaded
    private rebuildGrid(): void {
        this.buildColumns();
        this.buildRows();
        // totalQTY can be recalculated here if you want:
        const filledRows = (this.rangeStockListPayload || []).filter(x => this.normalizeCode(x.vendorItemCode));
        this.totalQTY = this.sharedService.getTotal(filledRows, 'vendorItemCode');
    }

    // Hook into your existing lifecycle:
    // 1) After Generate Range (checkRange), call rebuildGrid()
    private _orig_checkRange: any;



    private _afterCheckRangeGridRefresh(): void {
        if (this.SPH_RANGE?.length && this.CYL_RANGE?.length) {
            this.rebuildGrid(); // buildColumns + buildRows
            // Make absolutely sure edit payload reflects into the grid
            this.seedFromExistingPayload();

            if (this.currentStock && this.dataSource?.rangeStockListPayload) {
                this.setCurrentStock(this.dataSource.rangeStockListPayload);
            }
            if (this.previousStock) {
                this.getAllAvailableStock(
                    this.companyBranchId,
                    this.itemCatalogGroupId,
                    ((this.sectionsArray as any).at(0).get('childern') as any).at(0).get('max').value > 0
                );
            }
        } else {
            this.gridColumns = [];
            this.gridRows = [];
        }
    }
    // Ensure the grid displays existing values in edit mode using incoming payload
    private seedFromExistingPayload(): void {
        const seed = this.dataSource?.rangeStockListPayload || [];
        if (!this.gridRows?.length || !seed.length) return;

        const lookup = new Map<string, string>();
        for (const item of seed) {
            const sph = Number(item.sph);
            const cyl = Number(item.cyl);
            lookup.set(`${sph}|${cyl}`, item.vendorItemCode ?? '');
        }

        for (const row of this.gridRows) {
            const sph = Number(row.__sphKey);
            for (const cyl of this.CYL_RANGE || []) {
                const key = `${sph}|${Number(cyl)}`;
                const field = this.colField(cyl);
                const v = lookup.get(key);
                if (typeof v !== 'undefined') {
                    row[field] = v;
                }
            }
        }
        // Trigger change detection
        this.gridRows = [...this.gridRows];
    }
    /** Commit any pending cell edit and return the details derived from the grid */
    public async commitAndGetDetails(): Promise<any[]> {
        await this.grid?.instance.saveEditData();
        this.grid?.instance.closeEditCell();

        const lookup = this.existingDetailLookup();
        const details: any[] = [];
        if (!this.gridRows?.length || !this.CYL_RANGE?.length) return details;

        for (const row of this.gridRows) {
            const sph = Number(row.__sphKey);
            for (const cyl of this.CYL_RANGE) {
                const field = this.colField(cyl);
                const code = (row[field] ?? '').toString().trim();
                if (code !== '') {
                    const key = `${sph}|${Number(cyl)}`;
                    const ex = lookup.get(key) || {};
                    details.push({
                        sph,
                        cyl: Number(cyl),
                        vendorItemCode: code,
                        // carry ids when editing, otherwise 0 for new cells
                        vendorItemCatalogId: Number(ex.vendorItemCatalogId || 0),
                        vendorItemCatalogDetailId: Number(ex.vendorItemCatalogDetailId || 0),
                        active: true,
                    });
                }
            }
        }

        this.rangeStockListPayload = details;
        return details;
    }
    public getRangeSummary() {
        const sphArr = Array.isArray(this.SPH_RANGE) ? this.SPH_RANGE : [];
        const cylArr = Array.isArray(this.CYL_RANGE) ? this.CYL_RANGE : [];

        const sphmin = sphArr.length ? Math.min(...sphArr) : null;
        const sphmax = sphArr.length ? Math.max(...sphArr) : null;
        const cylmin = cylArr.length ? Math.min(...cylArr) : null;
        const cylmax = cylArr.length ? Math.max(...cylArr) : null;

        // If you keep ADD min/max in this component, expose them; otherwise null
        const addmin = (this as any).addmin ?? null;
        const addmax = (this as any).addmax ?? null;

        // If CX branch needs sections, expose them if present
        const sections = (this as any).sections ?? [];

        return { sphmin, sphmax, cylmin, cylmax, addmin, addmax, sections };
    }

    /**
     * @name destroy component
     */
    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        // this.subscription.unsubscribe();
    }

    private applyStockValueToGrid(sph: number | string, cyl: number | string, value: number | string) {
        if (!this.gridRows?.length) {
            return;
        }
        const rowIndex = this.gridRows.findIndex(row => Number(row.__sphKey) === Number(sph));
        if (rowIndex === -1) {
            return;
        }
        const field = this.colField(Number(cyl));
        const normalized = value == null ? '' : String(value);
        this.gridRows[rowIndex][field] = normalized;
        try {
            this.grid?.instance?.cellValue(rowIndex, field, normalized);
        } catch { }
    }

    private buildCellKey(sph: number | string, cyl: number | string): string {
        return `${Number(sph)}|${Number(cyl)}`;
    }

    private buildAllowedCellKey(sph: number | string, cyl: number | string): string {
        return `${Math.abs(Number(sph)).toFixed(2)}|${Math.abs(Number(cyl)).toFixed(2)}`;
    }

    private isCellAllowed(sph: number | string, cyl: number | string): boolean {
        return !this.allowedRangeCells || this.allowedRangeCells.has(this.buildAllowedCellKey(sph, cyl));
    }

    private refreshGridBadges() {
        try {
            this.grid?.instance?.refresh();
        } catch { }
    }

    private renderBadge(cell: HTMLElement, className: string, value?: number | null) {
        if (!cell) {
            return;
        }
        const existing = cell.querySelector<HTMLElement>(`.${className}`);
        if (value == null || Number.isNaN(value)) {
            existing?.remove();
            return;
        }

        cell.style.position = 'relative';
        if (existing) {
            existing.textContent = `${value}`;
            return;
        }

        const badge = document.createElement('span');
        badge.className = className;
        badge.textContent = `${value}`;
        cell.appendChild(badge);
    }

    private isPositiveRange(): boolean {
        const sections = this.sectionsArray as FormArray;
        const children = sections?.at(0)?.get('childern') as FormArray;
        const maxControl = children?.at(0)?.get('max');
        const maxValue = maxControl && maxControl.value != null ? Number(maxControl.value) : NaN;
        return Number.isFinite(maxValue) ? maxValue > 0 : false;
    }

    private buildAvailableStockCacheKey(companyBranchId: number, itemCatalogGroupId: number, isPositiveRange: boolean): string {
        return `${companyBranchId || 0}|${itemCatalogGroupId || 0}|${isPositiveRange ? 1 : 0}`;
    }
}
